import { ChangeEvent } from "react";
import {
  ProfileAction,
  EDITING_PROFILE_FORM,
  CHANGE_PASSWORD_REQUEST,
  CHANGING_PASSWORD,
  END_ACTION,
} from "./actionTypes";

// TODO: Remove unused actionTypes/Creators for old change password modal
export const startChangePassword = (): ProfileAction => ({
  type: CHANGING_PASSWORD,
});

export const handleClose = (): ProfileAction => ({
  type: END_ACTION,
});

export const changePasswordRequest = (): ProfileAction => ({
  type: CHANGE_PASSWORD_REQUEST,
});

// TODO: uh..???
export const handleSubmit = (func: any) => func();

export const handleChange = (
  e: ChangeEvent<HTMLInputElement>,
  inputId: null | string
): ProfileAction => {
  let inputValue: string | boolean | typeof e = "";

  if (!inputId) {
    // eslint-disable-next-line
    inputId = e.target.id;
    if (e.target.type === "checkbox") {
      inputValue = e.target.checked;
    } else {
      inputValue = e.target.value;
    }
  } else {
    inputValue = e;
  }

  return {
    type: EDITING_PROFILE_FORM,
    input_id: inputId,
    input_value: inputValue,
  };
};
